import { Component, OnInit } from '@angular/core';
import { ServiceConfigService } from '@app/services/service-config.service';

@Component({
  selector: 'nh-smart-app-banner',
  templateUrl: './smart-app-banner.component.html',
  styleUrls: ['./smart-app-banner.component.scss'],
  standalone: false
})
export class SmartAppBannerComponent implements OnInit {
  showBanner = false;
  isIOS = false;
  isAndroid = false;
  isSafari = false;
  deepLinkUrl = '';

  readonly IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/tenncare/id1435791637';
  readonly ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=gov.tn.teds';

  private readonly BANNER_DISMISSED_KEY = 'smartAppBannerDismissed';

  constructor(private serverConfig: ServiceConfigService) {}

  ngOnInit(): void {
    this.detectPlatform();
    this.detectBrowser();
    this.checkBannerVisibility();
    this.deepLinkUrl = this.serverConfig.getServerConfig().tccMobileAppDeepLink || '';
  }

  private detectPlatform(): void {
    // Try modern User-Agent Client Hints API first (Chrome 90+, Edge 90+)
    if ((navigator as any).userAgentData) {
      const uaData = (navigator as any).userAgentData;
      this.isAndroid = uaData.platform === 'Android';
    }

    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    
    // Detect iOS - Safari, Chrome, Firefox, Edge on iOS
    if (!this.isIOS) {
      this.isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
      
      // Detect iPad on iOS 13+ which reports as "Macintosh"
      if (!this.isIOS && /Macintosh/.test(userAgent)) {
        const hasTouch = 'ontouchend' in document;
        const hasTouchPoints = navigator.maxTouchPoints > 1;
        if (hasTouch && hasTouchPoints) {
          this.isIOS = true;
        }
      }
    }
    
    // Detect Android - Chrome, Firefox, Edge, Samsung Internet, Opera, etc.
    if (!this.isAndroid) {
      this.isAndroid = /android/i.test(userAgent);
    }
  }

  private checkBannerVisibility(): void {
    // Only show on mobile devices
    if (!this.isIOS && !this.isAndroid) {
      this.showBanner = false;
      return;
    }

    if (this.isStandalone()) {
      this.showBanner = false;
      return;
    }

    this.showBanner = true;
  }

  private isStandalone(): boolean {
    return (
      (window as any).navigator.standalone === true || // iOS Safari
      window.matchMedia('(display-mode: standalone)').matches // Android/Chrome
    );
  }

    // Check if banner was recently dismissed
    // const dismissedData = localStorage.getItem(this.BANNER_DISMISSED_KEY);
    // if (dismissedData) {
    //   const dismissedTime = parseInt(dismissedData, 10);
    //   const daysSinceDismissal = (Date.now() - dismissedTime) / (1000 * 60 * 60 * 24);
    //   if (daysSinceDismissal < this.DISMISS_DURATION_DAYS) {
    //     this.showBanner = false;
    //     return;
    //   }
    // }


  private detectBrowser(): void {
    // Safari doesn't support userAgentData API — if it exists, it's not Safari
    if ((navigator as any).userAgentData) {
      this.isSafari = false;
      return;
    }
    const userAgent = navigator.userAgent || '';
    this.isSafari = /Safari/.test(userAgent) && !/Chrome|CriOS|FxiOS|Edg|OPR|SamsungBrowser/.test(userAgent);
  }

  dismissBanner(): void {
    this.showBanner = false;
    localStorage.setItem(this.BANNER_DISMISSED_KEY, Date.now().toString());
  }

  openDeepLink(): void {
     if (this.isIOS && !this.isSafari) {
      // iOS Chrome: open in new tab so iOS can intercept the Universal Link.
      // The guard (app-store-redirect.guard) will close the tab after redirecting to the store.
      window.open(this.deepLinkUrl, '_self');
    } else {
      // Android Chrome / all others: navigate directly
      window.location.href = this.deepLinkUrl;
    }
  }
}